import { LeadsFunnelLeadCardSkeleton } from '../../LeadsFunnelLeadCardSkeleton';

import type { FC } from 'react';

import './LeadsFunnelStageColumnSkeleton.scss';

interface LeadsFunnelStageColumnSkeletonProps {
  cardCount?: number;
}

const DEFAULT_CARD_COUNT = 4;

export const LeadsFunnelStageColumnSkeleton: FC<
  LeadsFunnelStageColumnSkeletonProps
> = ({ cardCount = DEFAULT_CARD_COUNT }) => (
  <section className="LeadsFunnelStageColumnSkeleton" aria-hidden="true">
    <div className="LeadsFunnelStageColumnSkeleton__header">
      <span className="LeadsFunnelStageColumnSkeleton__color" />
      <div className="LeadsFunnelStageColumnSkeleton__title-block">
        <span className="LeadsFunnelStageColumnSkeleton__line LeadsFunnelStageColumnSkeleton__line--title" />
        <span className="LeadsFunnelStageColumnSkeleton__line LeadsFunnelStageColumnSkeleton__line--funnel" />
      </div>
      <span className="LeadsFunnelStageColumnSkeleton__count" />
    </div>

    <div className="LeadsFunnelStageColumnSkeleton__list">
      {Array.from({ length: cardCount }, (_, index) => (
        <LeadsFunnelLeadCardSkeleton key={`funnel-card-skeleton-${index}`} />
      ))}
    </div>
  </section>
);
